import axios from "../axios/axios";
import { PageResponse } from "../types/medicineSearch.types";
import { MissedCallResponse } from "../types/missedCalls.types";

// ITAM-2746. Both endpoints require ADMIN or PHARMACIST_USER, which every
// session that can reach /pharmacist-profile already has, so the shared axios
// instance is right: its global-logout interceptor fires only on 401/403, and
// the 404/409 this feature depends on pass through untouched.

export const MISSED_CALLS_PAGE_SIZE = 10;

export interface MissedCallsQuery {
  pageNum: number;
  pageSize?: number;
  /** ISO-8601 local date-time, filters on the same column as callDateTime. */
  from?: string;
  to?: string;
}

/** Newest first: the backend fixes the sort to created:desc, the client does not sort. */
export const getMissedCalls = (
  query: MissedCallsQuery,
  signal?: AbortSignal
): Promise<PageResponse<MissedCallResponse>> =>
  axios
    .get<PageResponse<MissedCallResponse>>("/online_consult/missed", {
      params: {
        pageNum: query.pageNum,
        pageSize: query.pageSize ?? MISSED_CALLS_PAGE_SIZE,
        ...(query.from && { from: query.from }),
        ...(query.to && { to: query.to }),
      },
      signal,
    })
    .then((res) => res.data);

/**
 * "Označi kao kontaktiran". Idempotent: a second call on an already-contacted
 * row is a 200 no-op. 409 means the consult is not a missed call, 404 means it
 * does not exist; both reach the caller unchanged.
 *
 * No AbortSignal, deliberately. Aborting a write only stops the client from
 * hearing the answer; it cannot roll back a mutation the server may already
 * have committed, so offering the parameter would invite a caller to believe
 * in a cancellation that did not happen. Add one when a real caller needs it.
 */
export const markMissedCallContacted = (consultId: number): Promise<void> =>
  axios.put(`/online_consult/${consultId}/contacted`).then(() => undefined);
